import {Link} from 'react-router-dom';
import { useLanguage } from "../components/Language.js";

const Navigation = () => {

    const {language} = useLanguage();

    return (
        <nav>
            <h4> Temporary navigation bar for ease of testing:</h4>
            <div className="nav-pages">
                <Link to="/">Home Page</Link>
                <Link to="/about">About Page</Link>
                <Link to="/contact">Contact Page</Link>
                <Link to="/map">Map Page</Link>
            </div>
        </nav>
    );
};
  
export default Navigation;